<template>
  <div class="temporary-limit-container">
    <div class="animate-container">
      <img src="../assets/icon_arrow.png" />
    </div>
    <div class="content">
      <span class="danger">{{ temporaryLimit }}</span>元临额，限时最高可提<span class="danger">{{ maxLimit }}</span>元
    </div>
    <img src="../assets/icon_info@2x.png" class="info" @click="visible=true" />

    <nd-dialog
      v-model="visible"
      close-btn
      :footer="false"
    >
      <div class="content-container">
        <div class="content-title">临时提额说明</div>
        <div class="content-detail">
          <p>临时提额仅限当日1次提现申请使用，一经申请提现，临时额度视为使用，当次不再生效。</p>
          <p> 临时额度若一次未能完全使用，剩余额度随已使用部分失效，不可继续再次使用。</p>
        </div>
      </div>
    </nd-dialog>
  </div>
</template>
<script>
export default {
  name: 'TemporaryLimit',
  data () {
    return {
      visible: false
    }
  },
  props: {
    temporaryLimit: {
      type: Number,
      default: 0
    },
    maxLimit: {
      type: Number,
      default: 0
    }
  }
  
}
</script>
<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.temporary-limit-container {
  height: 48px;
  padding: 0 10px;
  background: #fff1df;
  border-radius: 20px 100px 100px 0px;
  display: flex;
  font-size: 24px;
  color: #763E12;
  align-items: center;
  width: fit-content;
  .content-container {
    color: #333;
    padding:0  40px 40px 40px;
    .content-title {
      font-size: 42px;
      text-align: center;
      font-weight: bold;
    }
    .content-detail {
     p { margin-top: 20px;}
    }
  }
  gap: 10px;
  .animate-container {
    width: 50px;
    height: 36px;
    background: url(../assets/icon-money.png) no-repeat;
    background-size: 36px 36px;
    position: relative;
    img {
      width: 23px;
      height: 27px;
      position: absolute;
      left: 20px;
      bottom: -5px;
      animation: toTop 0.3s infinite alternate;
    }
    @keyframes toTop {
      to {
        transform: translateY(-10px);
      }
    }
  }
  .danger {
    color: #f07c28;
  }
  .info {
    width: 24px;
  }
}
</style>
